export default __webpack_public_path__ + "static/media/background-img.cd7ee705.jpg";